export const CAMERA_VIEW = {
  PERSPECTIVE: 0,
  TOP: 1,
  FRONT: 2,
  SIDE: 3,
} as const;

export const DEFAULT_CAMERA_SETTINGS = {
  position: [-25, 25, 0] as [number, number, number],
  fov: 50,
  /** 가까운 측정·점군을 확대해 볼 때 잘리지 않도록 three 기본값(0.1)보다 작게 둡니다. */
  near: 0.01,
  far: 2000,
};

export const POPUP_CAMERA_INITIAL_SIZE = {
  width: 600,
  height: 400,
} as const;

// TODO: remove
export const POPUP_MESSAGE_TYPE = 'POPUP_MESSAGE_TYPE';

export const POPUP_MESSAGE = {
  REGISTER_CAMERA_IMAGE: 'REGISTER_CAMERA_IMAGE',
  /**
   * 부모 -> 팝업. 오슬로 모자이크 한 장과 칸 배치(VPF-5197). 패널이 모자이크로 그리는 동안
   * 카메라별 원본 대신 보냅니다. 팝업은 칸을 잘라 그립니다(CameraPopup/cameraMosaicTile.ts).
   */
  REGISTER_CAMERA_MOSAIC: 'REGISTER_CAMERA_MOSAIC',
  UNREGISTER_CAMERA_IMAGE: 'UNREGISTER_CAMERA_IMAGE',
  FOCUS_CAMERA_IMAGE: 'FOCUS_CAMERA_IMAGE',
  /** 부모 -> 팝업. 이미지와 같은 프레임의 라이다 투영 결과 */
  REGISTER_CAMERA_POINT: 'REGISTER_CAMERA_POINT',
  /**
   * 팝업 -> 부모. 지금 크게 보고 있는 카메라 이름.
   * 투영 결과는 용량이 커서 이 카메라 것만 보냅니다(썸네일은 이미지만).
   */
  SET_POINT_CAMERA: 'SET_POINT_CAMERA',
} as const;

export const MAP_MODE_ROTATION = [Math.PI / 2, 0, 0] as const;
